import { Workbox } from 'workbox-window'

let workbox: Workbox | undefined = undefined

export let registrationPromise: Promise<ServiceWorkerRegistration | undefined> | undefined

let showUpdateAppPrompt = false
export function shouldShowUpdateAppPrompt() {
    return showUpdateAppPrompt
}

if ('serviceWorker' in navigator) {
    workbox = new Workbox('/service-worker.js')

    const showSkipWaitingPrompt = () => {
        showUpdateAppPrompt = true
    }
    workbox.addEventListener('waiting', showSkipWaitingPrompt)
    workbox.addEventListener('externalwaiting', showSkipWaitingPrompt)

    if (process.env.NODE_ENV === 'development') {
        // workbox.register()
    } else {
        registrationPromise = workbox.register()
    }
}

export default workbox
